import React, { useState } from 'react';

// Replace this with the actual path to your local JPEG file or URL
import LogoImg from './logo22.jpeg'; 

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="relative bg-transparent z-50">
      {/* Main Navbar Wrapper */}
      <div className="max-w-7xl mx-auto px-6 py-4 md:px-8 flex items-center justify-between md:justify-center">
        
        {/* Mobile View Layout (Hidden on Desktop) */}
        <div className="flex md:hidden items-center justify-between w-full">
          <button 
            onClick={() => setIsOpen(!isOpen)}
            className="text-gray-700 hover:text-amber-800 focus:outline-none"
            aria-label="Toggle menu"
          >
            {isOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
          
          <a href="#" className="block">
            <img src={LogoImg} alt="Tuljai Logo" className="w-14 h-14 object-cover rounded-full shadow-md" />
          </a>
          
          {/* Invisible spacer to perfectly balance the mobile layout row */}
          <div className="w-6"></div>
        </div>

        {/* Desktop Balanced Layout (Hidden on Mobile) */}
        <div className="hidden md:flex items-center space-x-12 lg:space-x-16 w-full justify-center">
          
          {/* Left Menu Options */}
          <div className="flex items-center space-x-8 lg:space-x-12 text-sm font-medium text-gray-800 tracking-wide uppercase">
            <a href="/" className="hover:text-amber-800 transition-colors">Home</a>
            <a href="/catalouge" className="hover:text-amber-800 transition-colors">Catalouge</a>
          </div>

          {/* Centralized JPEG Logo */}
          <div className="flex-shrink-0 mx-4">
            <a href="#" className="block transition-transform duration-200 hover:scale-105">
              <img 
                src={LogoImg} 
                alt="Tuljai Logo" 
                className="w-16 h-16 object-cover rounded-full shadow-md border border-amber-800/10"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="hidden w-16 h-16 bg-[#5c1d24] rounded-full items-center justify-center text-amber-400 font-serif font-bold text-xs tracking-wider shadow-md">
                TULJAI
              </div>
            </a>
          </div>

          {/* Right Menu Options */}
          <div className="flex items-center space-x-8 lg:space-x-12 text-sm font-medium text-gray-800 tracking-wide uppercase">
            <a href="/about" className="hover:text-amber-800 transition-colors">About</a>
            <a href="/contact" className="hover:text-amber-800 transition-colors">Contact</a>
          </div>

        </div>
      </div>

      {/* Mobile Drawer Dropdown Menu */}
      {isOpen && (
        <div className="absolute top-full left-0 w-full bg-[#F9F6F0]/95 backdrop-blur-md shadow-xl transition-all duration-200 ease-in-out md:hidden">
          <div className="flex flex-col px-6 py-4 space-y-4 text-base font-medium text-gray-800 tracking-wider uppercase">
            <a href="/" className="hover:text-amber-800 py-1 transition-colors border-b border-gray-100">Home</a>
            <a href="/catalouge" className="hover:text-amber-800 py-1 transition-colors border-b border-gray-100">Catalouge</a>
            <a href="/about" className="hover:text-amber-800 py-1 transition-colors border-b border-gray-100">About</a>
            <a href="/contact" className="hover:text-amber-800 py-1 transition-colors border-b border-gray-100">Contact</a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;